import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import type {
    HedisPopUpConfig,
} from 'interfaces/MemberPortalConfig';
import { CampaignPopUp } from 'components/molecules/CampaignPopUp/CampaignPopUp';

const SPLIT_TEXT = '$$LINK$$';

export type HedisPopUpProps = {
    hedisPopUpConfig: HedisPopUpConfig;
};

export function HedisPopUp({ hedisPopUpConfig }: HedisPopUpProps) {
    if (!hedisPopUpConfig) {
        return null;
    }

    const renderBody = useCallback((): JSX.Element | string => {
        const splittedText = hedisPopUpConfig.popUpBody.split(SPLIT_TEXT);
        if (splittedText.length !== 2) {
            console.error('Invalid popUp config, text should only contain one link');
            return hedisPopUpConfig.popUpBody;
        }

        const linkText = (
            <strong>
                <Link
                    to={`/message-center/new?initialCategory=${hedisPopUpConfig.messageCenterCategory}`}
                >
                    {hedisPopUpConfig.linkText}
                </Link>
            </strong>
        );

        return (
            <p>
                {splittedText[0]}
                {linkText}
                {splittedText[1]}
            </p>
        );
    }, [hedisPopUpConfig]);


    return (
        <CampaignPopUp
            alertType={hedisPopUpConfig.alertType}
            message={renderBody()}
            title={hedisPopUpConfig.popUpTitle}
            hedisConfig={hedisPopUpConfig}
        />
    );
}
